var map = {
	"./bootstrap.svg": 8810,
	"./cloudinary.svg": 2959,
	"./css.svg": 8790,
	"./expressjs.svg": 9784,
	"./figma.svg": 3077,
	"./framermotion.svg": 5729,
	"./github.svg": 2,
	"./gmail.svg": 8690,
	"./html.svg": 6841,
	"./javascript.svg": 9796,
	"./jquery.svg": 351,
	"./linkedin.svg": 463,
	"./mongodb.svg": 1263,
	"./nodejs.svg": 8966,
	"./phone-android-outline.svg": 5314,
	"./react.svg": 7916,
	"./reactnative.svg": 2439,
	"./reactrouter.svg": 3398,
	"./redux.svg": 4906,
	"./sass.svg": 1910,
	"./socketdotio.svg": 6995,
	"./solidity.svg": 9002,
	"./tailwindcss.svg": 5253,
	"./telegram.svg": 873,
	"./twitter.svg": 8402,
	"./typescript.svg": 513,
	"./web.svg": 1878,
	"./webrtc.svg": 8031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;